import React from "react";
import Lottie from "lottie-react";
//MUI
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
//Components
import WideLayout from "../../layouts/WideLayout";
import { isMobile, isTablet } from "react-device-detect";
import animationData from "../../assets/animation/404.json";
const NotFound = () => {
    return (
        <WideLayout
            breadcrumbsItems={
                [{
                    title: "",
                    to: "/",
                }]
            }
            title="صفحه مورد نظر یافت نشد  |  404"
            metas={{
                robots: "noindex",
            }}
        >
            <Grid xs={12} style={{ marginTop: !isMobile && !isTablet ? '-100px' : '10px' }}>
                <Lottie
                    loop={true}
                    autoplay={true}
                    animationData={animationData}
                    style={{
                        width: !isMobile && !isTablet ? "500px" : '90%',
                        height: !isMobile && !isTablet ? "450px" : '90%',
                        margin: "0 auto",
                    }}
                />
                <Box color="#950000" fontSize={24} textAlign="center" fontWeight="bold">
                    صفحه مورد نظر یافت نشد :(
        </Box>
            </Grid>
        </WideLayout>
    );
};
export default NotFound;
